<div class="app-alert" role="alert">
  <div class="app-alert__main">
    <div
      *ngIf="data.messageType === 'success'"
      class="app-alert__icon app-alert__icon--success"
      aria-hidden="true"
    >
      <svg
        width="17"
        height="17"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M21.801 10A10 10 0 1 1 17 3.335" />
        <path d="m9 11 3 3L22 4" />
      </svg>
    </div>

    <div
      *ngIf="data.messageType === 'warning'"
      class="app-alert__icon app-alert__icon--warning"
      aria-hidden="true"
    >
      <svg
        width="17"
        height="17"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path
          d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"
        />
        <path d="M12 9v4" />
        <path d="M12 17h.01" />
      </svg>
    </div>

    <div
      *ngIf="data.messageType === 'error'"
      class="app-alert__icon app-alert__icon--error"
      aria-hidden="true"
    >
      <svg
        width="17"
        height="17"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="m15 9-6 6" />
        <path d="m9 9 6 6" />
      </svg>
    </div>

    <div class="app-alert__text">
      <p *ngIf="data.title" class="app-alert__title">{{ data.title }}</p>
      <p *ngIf="data.message" class="app-alert__message" [class.app-alert__message--detail]="data.title">
        {{ data.message }}
      </p>
      <button *ngIf="data.actionLabel" type="button" class="app-alert__action" (click)="runAction()">
        {{ data.actionLabel }}
      </button>
    </div>
  </div>

  <button
    type="button"
    class="app-alert__close"
    (click)="closeSnackbar()"
    [attr.aria-label]="'APP_BUTTONS.CLOSE' | translate"
  >
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M18 6 6 18M6 6l12 12" />
    </svg>
  </button>
</div>
